<template>
    <div class="editor-element-tools-wrapper">
        <button class="editor-option" v-if="element.itemType == 'text_element'">
            Edit Text
        </button>
        <div class="option-divider"></div>
        <button class="editor-option" @click="deleteNode()">
            ? Help
        </button>
        <div class="option-divider"></div>
        <widgetDropdown v-model="isMenuOpen" :right="true" :hover="false" :interactive="true">
            <button class="btn-dropdown btn-menu">
                <img class="icon" src="@/views/Resume/icons/more.svg" />
            </button>
            <div slot="dropdown" class="dropdown-widget" style="right: -9px">
                <a class="dropdown-item" href="#" @click="copyNode()">Copy</a>
                <a class="dropdown-item" href="#" @click="cutNode()">Cut</a>
                <a class="dropdown-item" href="#" @click="pastNode()">Paste</a>
                <a class="dropdown-item" href="#" @click="dublicateNode()">Duplicate</a>
                <a class="dropdown-item" href="#" @click="deleteNode()">Delete </a>
                <a v-if="element.itemType == 'container_element'" class="dropdown-item" href="#" @click="saveNode()">Save
                    Component</a>
            </div>
        </widgetDropdown>
    </div>
</template>
<script>
export default {
    name: "editor-element-tools-wrapper",
    components: {},
    props: {
        element: {
            type: Object,
            default: () => {
                return {};
            },
            required: true,
        },
    },
    data() {
        return {
            isMenuOpen: false
        }
    },
    computed: {},
    watch: {},
    mounted() {
    },
    methods: {
        saveNode() {
            let vm = this;
            vm.onclose();
            vm.$emit("saveNode");
        },
        copyNode() {
            let vm = this;
            vm.onclose();
            vm.$localStorage.set("editor_copied_node", JSON.stringify(vm.element));
        },
        cutNode() {
            let vm = this;
            vm.$localStorage.set("editor_copied_node", JSON.stringify(vm.element));
            vm.deleteNode();
        },
        pastNode() {
            let vm = this;
            vm.$emit("pastNode");
        },
        dublicateNode() {
            let vm = this;
            vm.onclose();
            vm.$emit("dublicateNode");
        },
        deleteNode() {
            let vm = this;
            vm.onclose();
            vm.$emit("deleteNode");
        },
        onclose() {
            let vm = this;
            vm.isMenuOpen = false;
            vm.$emit("close");
        }

    },
};
</script>

<style lang="scss" scoped>
$assets: "~@/assets";

.editor-element-tools-wrapper {
    position: absolute;
    height: 30px;
    width: max-content;
    padding: 0px 10px;
    background-color: #fff;
    box-shadow: 0px 0px 8px #9c9c9c;
    top: var(--cv-tool-options-top-possition, -35px);
    left: 0px;
    z-index: 9999;
    border-radius: 4px;
    display: flex;
    align-items: center;
    transform-origin: 0 0;
    transform: var(--inverce-zoom);

    .editor-option {
        border-right: 1px solid #9c9c9c;
        padding: 4px 8px;

        &:hover {
            background-color: #f2f2f2;
        }
    }
}
</style>